import type { FC } from 'react';
import { Badge } from '@/components/ui/badge';

export const UnknownBadge: FC = () => {
  return <Badge variant="secondary">unknown</Badge>;
};
